export default "__VITE_ASSET__BIwdxwqF__"